// Non-blocking "a new version shipped" banner — lifted from apps/web (the
// 2026-06-11 stale-tab incident class). Never auto-reloads; the admin
// refreshes when convenient. Inline refresh glyph instead of lucide-react
// so the admin app stays dependency-light.

import { useVersionCheck } from '../hooks/useVersionCheck';

export function UpdateToast() {
  const updateAvailable = useVersionCheck();
  if (!updateAvailable) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[100] flex justify-center px-4 pb-[max(env(safe-area-inset-bottom,0px),1rem)]">
      <div className="flex w-full max-w-content items-center gap-3 rounded-2xl bg-ink-900 px-4 py-3 text-surface shadow-lg">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.25"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="shrink-0"
          aria-hidden
        >
          <path d="M21 12a9 9 0 1 1-2.64-6.36" />
          <path d="M21 3v6h-6" />
        </svg>
        <p className="flex-1 text-[13.5px] font-medium leading-snug">
          A new version of the admin panel is available.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="h-9 shrink-0 rounded-lg bg-surface px-4 text-[13px] font-semibold text-ink-900 transition hover:bg-ink-100"
        >
          Refresh
        </button>
      </div>
    </div>
  );
}
